import React, { useRef } from 'react';

const event = new CustomEvent('onLinkClick', { bubbles: true });

const Link = ({ id, children }) => {
  const ref = useRef();

  return (
    <span
      ref={ref}
      className="dataEntryLink"
      id={id}
      onClick={(e) => e.target.dispatchEvent(event)}
    >
      {children}
    </span>
  );
};

export default Link;
